module.exports = __webpack_public_path__ + "assets/Pentagon.7829214b9f88420dc5382355858b2ae5.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Pentagon.gmt
// module id = 982
// module chunks = 0